// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3BdnJ","additionalInfo":"AgreementModal_additionalInfo__2v_jy"};